const menuRoutes = [
    { menuId: 2000, route: "Rastreamento", active: true },
    { menuId: 2010, route: "fleet", active: true },
    { menuId: 2040, route: "mapfilters", active: true },
    { menuId: 2060, route: "vehicles/nearby", active: true },
    { menuId: 2100, route: "vehicles/nickname", active: true },
    { menuId: 2109, route: "groups", leveName: "GESTOR REGIONAL", active: true },
    { menuId: 2110, route: "groups", leveName: "GESTOR REGIONAL", active: true },
    { menuId: 2113, route: "linked-vehicles", leveName: "GESTOR REGIONAL", active: true },
    { menuId: 2114, route: "group-users", leveName: "GESTOR REGIONAL", active: true },
    { menuId: 4000, route: null, leveName: "GESTOR REGIONAL", active: true },
    { menuId: 4010, route: "visitpoint", active: true },
    { menuId: 4030, route: "electric-fence", active: true },
    { menuId: 4040, route: "risk-area", active: true },
    { menuId: 6000, route: null, active: true },
    { menuId: 6900, route: "protocols", active: true },
    { menuId: 3000, route: null, leveName: "GESTOR REGIONAL", active: true },
    { menuId: 3010, route: "journeywork", active: true },
    { menuId: 3020, route: "vehiclepositions", active: true },
    { menuId: 3030, route: "travelleddistance", active: true },
    { menuId: 3040, route: "vehicleactivities", active: true },
    { menuId: 3060, route: "visitsvehicle", active: true },
    { menuId: 3070, route: "vehiclevisits", active: true },
    { menuId: 3100, route: "speedcontrol", active: true },
    { menuId: 5000, route: null, leveName: "GESTOR REGIONAL", edit: "S", active: true },
    { menuId: 5050, route: "driver", active: true },
    { menuId: 18000, route: null, leveName: "GESTOR REGIONAL", active: true },
    { menuId: 7000, route: null, leveName: "GESTOR REGIONAL", active: true },
    { menuId: 7010, route: "maintenances/items", active: false },
    { menuId: 7020, route: "maintenances/scheduling", active: false },
    { menuId: 7030, route: "maintenances/register", active: false },
    { menuId: 7040, route: "maintenances/pendings", active: false },
    { menuId: 7050, route: "maintenances/completed", active: false },
    { menuId: 7060, route: "maintenances/shipping", active: false },
    { menuId: 12000, level: 1, name: "Cadastro de Veículo", route: "vehicle", icon: "AiFillCar", leveName: "ADMINISTRADOR", edit: "S", active: true },
    { menuId: 12010, level: 2, name: "Veículo", route: "vehicle", icon: "AiFillCar", leveName: "ADMINISTRADOR", edit: "N", active: true },
    { menuId: 12020, level: 2, name: "Montadora", route: "manufacturer", icon: "FaFileSignature", leveName: "ADMINISTRADOR", edit: "N", active: true },
    { menuId: 12030, level: 2, name: "Modelo", route: "models", icon: "FaFileSignature", leveName: "ADMINISTRADOR", edit: "S", active: true },
    { menuId: 12040, level: 2, name: "Cor", route: "colors", icon: "FaFileSignature", leveName: "ADMINISTRADOR", edit: "S", active: true },
    { menuId: 12050, level: 2, name: "Categoria", route: "categories", icon: "FaFileSignature", leveName: "ADMINISTRADOR", edit: "S", active: true },
];

export default menuRoutes;
